import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { FORM_KEYS } from "../constants";
import { updateConvention } from "../../../store/conventionsSlice";
import { BRAND } from "../../../utils/constants";
import {
  updateLiveConvention,
  deleteLiveConvention,
} from "../../../store/liveConventions";
import { updateProduct } from "../../../store/conventionsSlice";

/**
 * @desc Save handler based on calculated difference.
 */
export const useHandlers = ({ difference }) => {
  const dispatch = useDispatch();

  // METHODS ------------------------------------------------------------------

  /**
   * @desc Update convention body.
   */
  const updateConventionBody = async ({ body, cname }) => {
    if (Object.entries(body).length) {
      await dispatch(
        updateConvention({
          ...body,
          name: cname,
        })
      );
    }
    return;
  };

  /**
   * @desc Update live status.
   */
  const updateLiveStatus = async ({ isLive, cname, brand }) => {
    if (![null, undefined].includes(isLive) && cname && brand) {
      const liveProps = {
        cname,
        brand,
      };
      const action = isLive ? updateLiveConvention : deleteLiveConvention;
      await dispatch(action(liveProps));
    }
    return;
  };

  /**
   * @desc Update convention products.
   */
  const updateConventionProducts = async ({ products, cname }) => {
    if (!products.length) return;
    const promises = [];
    products.forEach((product) => {
      const promise = dispatch(updateProduct({ product, cname }));
      promises.push(promise);
    });
    return Promise.allSettled(promises);
  };

  // HANDLERS -----------------------------------------------------------------

  const onSave = async (data) => {
    if (!Object.entries(difference).length) {
      toast.warn("Nothing to update.");
      return;
    }
    const cname = data[FORM_KEYS.CNAME];
    const {
      isLiveFunko,
      isLiveLoungefly,
      isLiveMondo,
      products = [],
      ...body
    } = difference;

    try {
      // Update Convention Body
      await updateConventionBody({ body, cname });

      // Update Live Status
      await updateLiveStatus({
        isLive: isLiveFunko,
        brand: BRAND.FUNKO,
        cname,
      });
      await updateLiveStatus({
        isLive: isLiveLoungefly,
        brand: BRAND.LOUNGEFLY,
        cname,
      });
      await updateLiveStatus({
        isLive: isLiveMondo,
        brand: BRAND.MONDO,
        cname,
      });

      // Update Products
      await updateConventionProducts({ products, cname });
      toast.success(`Success`);
    } catch (err) {
      toast.error(`Error: ${err.message}`);
    }
  };

  // HOOK ---------------------------------------------------------------------

  return { onSave };
};
